import React, { useEffect, useState } from 'react';
import { eventsAPI, unwrapList } from '../../services/api';
import { enqueue, flushQueue, readQueue } from '../../utils/offlineQueue';
import DeskStation from './DeskStation';
import { useLanguage } from '../../context/LanguageContext';

const CheckInStation = () => {
  const { t } = useLanguage();
  const [events, setEvents] = useState([]);
  const [eventId, setEventId] = useState('');
  const [walkIn, setWalkIn] = useState(false);
  const [queued, setQueued] = useState(readQueue().length);

  useEffect(() => {
    eventsAPI.adminList().then((response) => {
      const rows = unwrapList(response.data).filter((event) => event.status !== 'cancelled');
      setEvents(rows);
      if (rows[0]) setEventId(String(rows[0].id));
    }).catch(() => {});
    const flush = () => flushQueue((item) => {
      if (item.type !== 'check_in') return Promise.resolve();
      return eventsAPI.checkIn(item.payload).then((response) => response.data);
    }).then(setQueued);
    window.addEventListener('online', flush);
    flush();
    return () => window.removeEventListener('online', flush);
  }, []);

  return (
    <DeskStation
      title={t('desk.checkInTitle')}
      hint={t('desk.checkInHint', { n: queued })}
      selected={eventId}
      onSelect={setEventId}
      options={events.map((event) => (
        <option key={event.id} value={event.id}>{event.title}</option>
      ))}
      extra={(
        <label className="pos-check">
          <input type="checkbox" checked={walkIn} onChange={(event) => setWalkIn(event.target.checked)} />
          {t('desk.walkIn')}
        </label>
      )}
      onScan={async (q) => {
        const payload = { q, event_id: eventId, register_and_check_in: walkIn };
        if (!navigator.onLine) {
          setQueued(enqueue({ type: 'check_in', payload }));
          return { color: 'yellow', message: t('desk.queued'), code: 'queued' };
        }
        try {
          const response = await eventsAPI.checkIn(payload);
          return response.data;
        } catch (error) {
          if (!error.response) {
            setQueued(enqueue({ type: 'check_in', payload }));
            return { color: 'yellow', message: t('desk.queuedOffline'), code: 'queuedOffline' };
          }
          throw error;
        }
      }}
    />
  );
};

export default CheckInStation;
